import {
    GET_SET_DETAILS,
    GET_SET_DETAILS_SUCCESS,
    GET_SET_DETAILS_FAILURE,
    RESET_SET_DETAILS,
} from '../actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const setDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SET_DETAILS:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
            };
        case GET_SET_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case GET_SET_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        case RESET_SET_DETAILS:
            return initialState;
        default:
            return state;
    }
};

export default setDetailsReducer;